import { mergeMap, of } from "rxjs";
import { IsAccountValidGuard } from "./base/is-account-valid.guard";
import { LoadServicesGuard } from "./base/load-services.guard";
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class ReportGuard {

    constructor(
        private loadServicesGuard: LoadServicesGuard,
        private isAccountValidGuard: IsAccountValidGuard
    ) { }

    canActivate() {
        return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => {
            if (servicesLoaded) {
                return this.isAccountValidGuard.canActivate().pipe(mergeMap((valid: boolean) => {
                    if (valid) {
                        return of(true);
                    }
                }));
            }
        }));
    }
}